import APIKit from "../Allapis/Apikit/apikit";
import axios from "axios";
import {
  storeTokens,
  getAccessToken,
  getRefreshToken,
} from "../lib/utils/tokenUtils";
import { encodePassword } from "../lib/utils/passwordEncoder";
import { base_url } from "../base_urls";
import { Base64 } from "js-base64";

const toBase64 = (value) =>
  value == null || value === "" ? value : Base64.encode(String(value));

// Separate axios instance so refresh never hits APIKit interceptors
const refreshAxios = axios.create({
  baseURL: base_url,
});

/** One in-flight refresh — avoids rotated-token double-call failures */
let refreshPromise = null;

const pickTokens = (result = {}) => ({
  ...result,
  accessToken:
    result.accessToken ||
    result.token ||
    result.tokens?.accessToken ||
    result.tokens?.token,
  refreshToken:
    result.refreshToken ||
    result.refresh_token ||
    result.tokens?.refreshToken ||
    result.tokens?.refresh_token,
});

export const loginServer = async (body) => {
  try {
    const url = `/users/webLogin`;
    const encodedBody = {
      ...body,
      password: encodePassword(body.password),
      email: toBase64(body.email),
    };
    const result = await APIKit.post(url, encodedBody);

    if (result?.data?.success && result?.data?.result) {
      await StorageToken(result.data.result);
      if (!getAccessToken() || !getRefreshToken()) {
        storeTokens(pickTokens(result.data.result));
      }
    }
    return result;
  } catch (e) {
    return e.response ? e.response : e;
  }
};

export const StorageToken = async (token) => {
  storeTokens(pickTokens(token));
  if (token.otp) {
    localStorage.setItem("Otp", token.otp);
  }
};

/**
 * Call /users/refresh and store new tokens.
 * Concurrent callers share the same promise.
 * Throws on failure (does not swallow errors).
 */
export const refreshAccessToken = async () => {
  if (refreshPromise) {
    return refreshPromise;
  }

  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    throw new Error("No refresh token available");
  }

  refreshPromise = (async () => {
    const result = await refreshAxios.post(`/users/refresh`, { refreshToken });

    const tokens = result.data?.result || result.data || {};
    const accessToken = tokens.accessToken || tokens.token || null;
    const newRefreshToken =
      tokens.refreshToken || tokens.refresh_token || refreshToken;

    if (result.data?.success === false || !accessToken) {
      const err = new Error(
        result.data?.message || "Failed to refresh access token",
      );
      err.response = result;
      throw err;
    }

    storeTokens({
      accessToken,
      refreshToken: newRefreshToken,
    });

    return result;
  })().finally(() => {
    refreshPromise = null;
  });

  return refreshPromise;
};

export const logoutServer = async (body) => {
  try {
    return await refreshAxios.post(`/auth/logout`, body);
  } catch (e) {
    return e.response ? e.response : e;
  }
};
